import { createContext } from "react";

let Context = createContext();

export default Context;